exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "aside[data-v-e4b7b4a2]{min-height:100%;z-index:6}.logo[data-v-e4b7b4a2]{height:128px;min-width:300px;max-width:300px;display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center}.logo img[data-v-e4b7b4a2],.logo object[data-v-e4b7b4a2]{max-height:118px;max-width:270px;margin:auto}[data-v-e4b7b4a2] .toolbar__content div{margin:0!important}.highlight[data-v-e4b7b4a2]{border-bottom:1px dashed gray}[data-v-e4b7b4a2] .add-storage button{margin-left:auto;margin-top:15px;margin-right:40px}[data-v-e4b7b4a2] .list__tile--disabled{opacity:1!important}[data-v-e4b7b4a2] .list__tile--disabled .list__tile__title,[data-v-e4b7b4a2] .list__tile--disabled i{color:var(--primary_text)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-e4b7b4a2","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/drawer/Drawer.vue
// module id = 1058
// module chunks = 22